import { emperor } from '~/services';
import {
  OwnerGroupPortfolioStats,
  OwnerGroupRetentionExpiryRow,
  RetentionExpiryRow,
  RetentionQAOwnerGroupReport,
  RetentionQAReport
} from '~/types/analytics';

export const fetchRetentionExpiry = async (buildingId: string) => {
  return emperor.get<RetentionExpiryRow | RetentionExpiryRow[]>(
    `/v2/analytics/building/${encodeURIComponent(buildingId)}/retention-expiry`
  );
};

export const fetchOwnerGroupRetentionExpiry = async (ownerGroupId: string) => {
  return emperor.get<OwnerGroupRetentionExpiryRow | OwnerGroupRetentionExpiryRow[]>(
    `/v2/analytics/owner-group/${encodeURIComponent(ownerGroupId)}/retention-expiry`
  );
};

export const fetchOwnerGroupPortfolioStats = async (ownerGroupId: string) => {
  return emperor.get<OwnerGroupPortfolioStats>(
    `/v2/analytics/owner-group/${encodeURIComponent(ownerGroupId)}/portfolio-stats`
  );
};

export const fetchRetentionQaReport = async (month: string, dataType: 'buildings' | 'ownerGroups' = 'buildings') => {
  return emperor.get<RetentionQAReport | RetentionQAOwnerGroupReport>(
    `/v2/analytics/retention-qa-report?month=${encodeURIComponent(month)}&dataType=${dataType}`
  );
};

export const updateOwnerGroupRetentionPendingStatus = async (
  ownerGroupId: string,
  month: string,
  isPending: boolean
) => {
  return emperor.patch(
    `/v2/analytics/owner-group/${encodeURIComponent(ownerGroupId)}/retention-expiry/${encodeURIComponent(month)}/pending`,
    { isPending }
  );
};

export const updateRetentionPendingStatus = async (
  buildingId: string,
  month: string,
  isPending: boolean
) => {
  return emperor.patch(
    `/v2/analytics/building/${encodeURIComponent(buildingId)}/retention-expiry/${encodeURIComponent(month)}/pending`,
    { isPending }
  );
};

